// extracted by mini-css-extract-plugin
module.exports = {"label":"Toggle_label__8JMue","input":"Toggle_input__WeItr","padding":"Toggle_padding__4dyUW"};